import { render, staticRenderFns } from "./vehicleDiag.vue?vue&type=template&id=39db0f77&scoped=true"
import script from "./vehicleDiag.vue?vue&type=script&lang=js"
export * from "./vehicleDiag.vue?vue&type=script&lang=js"
import style0 from "./vehicleDiag.vue?vue&type=style&index=0&id=39db0f77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39db0f77",
  null
  
)

export default component.exports